import type { FunctionComponent, ReactElement } from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { toastActions } from '../../../store/slices/toast/slice';
import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';
import { Toast } from '../../toast/Toast';
import type { ToastConnectedProps } from '../types';

export const TableCloseNotifyToastConnected: FunctionComponent<ToastConnectedProps> = ({
  message,
  timeStamp,
  ...rest
}): ReactElement => {
  const dispatch = useCoreDispatch();

  const duration = useGameStateSlice.getTableCloseNotification()?.duration;
  const [timer, setTimer] = useState<number>(parseInt(duration || '0') * 60);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return (): void => {
      clearInterval(intervalId);
    };
  }, []);

  const _dynamicValues = useMemo(() => {
    if (timer) {
      const minutes = Math.floor(timer / 60);
      const seconds = timer - minutes * 60;
      const minutesStr = `0${minutes}`.slice(-2);
      const secondsStr = `0${seconds}`.slice(-2);
      return [`${minutesStr}:${secondsStr}`];
    } else {
      return [];
    }
  }, [timer]);

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  return (
    <Toast
      icon={<Icon icon={Icons.Timer} />}
      message={message}
      msgDynamicValues={_dynamicValues}
      onClose={closeFn}
      {...rest}
    />
  );
};
